import { LoadingState, ValidationError } from '../../commonTypes'
import { CategoryList } from '../Category/categoryListTypes'

export type EmpDepartmentListResponse = {
  departmentId: number
  departmentName: string
  supportManagementFlag: boolean
  allocationSupportFlag: boolean
}
export type CategoryListResponse = {
  id: number
  categoryName: string
  createdBy: string
  updatedBy: string
  createdDate: string
  updatedDate: string
}
export type PaymentList = {
  id: number
  paymentType: string
}
export type CountriesListResponse = {
  id: number
  name: string
  mobileCode: string
  countryCode: string
}
export type PaymentListSliceState = {
  getAllCategory: CategoryList[]
  paymentlist: PaymentList[]
  categoriesList: CategoryListResponse[]
  empDepartments: EmpDepartmentListResponse[]
  countriesList: CountriesListResponse[]
  creditCardsList: CreditCardListResponse[]
  reimbursementExpenseList: ReimbursementExpenseListResponse
  reimbursementData: ReimbursementExpenseList[]
  expenseDetails: GetExpenseDetails
  getExpensePaymentList: GetExpensePaymentList[]
  getpayAllatOnce: GetpayAllAtOnceProps
  isLoading: LoadingState
  isLoadingReimburse: LoadingState
  error: ValidationError
  selectedPaymentStatus: employeePaymentStatus
  paymentListSize: number
  paymentListValue?: string
  paymentTotalAmount: string
  fromDate: string | Date
  toDate: string | Date
  searchValue: string
  pageSize: number
  pageNum: number

  departmentNameValue: string
  categoryNameValue: string
  countryValue: string
  modeOfPaymentValue: string
  creditCardsValue: string
}

export type CreditCardListResponse = {
  cardId: number | string
  cardName: string
  cardNumber: string
  createdBy: string
  updatedBy: null
  createdDate: string
  updatedDate: null
}
export type getReimbursementExpenseListProps = {
  categoryId: number | string
  country: string
  creditCardId: number | string
  dateSelection: string
  departmentId: number | string
  endIndex: number
  from: string
  multipleSearch: string
  paymentMode: string
  paymentStatus: string
  startIndex: number
  to: string
}
export type ReimbursementExpenseListResponse = {
  size: number
  list: ReimbursementExpenseList[]
}
export type ReimbursementExpenseList = {
  formId: number
  expenseNumber: string
  toEmployee: EmployeeDetailsResponse
  categoryId: number
  categoryName: string
  subCategoryId: number
  subCategoryName: string
  deptId: number
  deptName: string
  project: ProjectList
  vendor: VendorListResponse
  purpose: string
  expenditureDate: string
  country: string
  currencyId: number
  currencyType: string
  paymentMode: string
  creditCardDetails: CreditCardListResponse
  chequeNumber: string
  chequeDate: null
  voucherNumber: string
  amount: string | number
  description: string
  isReimbursable: false
  empId: number
  saltKey: null
  paymentStatus: null
  remainingAmount: null
  amountInINR: string
  createdBy: string
  createdDate: string
  updatedBy: string
  updatedDate: string
  invoiceNumber: null
  isAutogenerated: null
}
export type EmployeeList = {
  id: number
  firstName: string
  lastName: string
  middleName: string
  designation: string
  role: string
  manager: string
  designationKrasDTO: string
  employeeSubmitted: string
  managerSubmitted: string
  acknowledged: string
  fullName: string
  profilePicPath: string
  thumbPicture: string
  profilePicGeneratedPath: string
  gender: string
  dob: string
  departmentName: string
  employmentTypeName: string
  jobTypeName: string
  imageData: string
  curentLocation: string
  baseLocation: string
  officialBirthday: string
  realBirthday: string
  maritalStatus: string
  emergencyContactName: string
  emergencyPhone: string
  emergencyRelationShip: string
  grade: string
  aboutMe: string
  homeNumber: string
  workNumber: string
  presentAddress: string
  presentCity: string
  presentZip: string
  presentLandMark: string
  permanentAddress: string
  permanentCity: string
  permanentZip: string
  permanentLandMark: string
  mobile: string
  homeCode: string
  workCode: string
  skillList: string
  userName: string
  alternativeMobile: string
  dateOfJoining: string
  informationList: string
  anniversary: string
  bankInformationList: string
  bioAttendanceDtoSet: string
  dates: string
  absentCount: number
  statusName: string
  emergencyContact: string
  relievingDate: string
  observationDTOList: string
  skypeId: string
  percent: string
  passportNumber: string
  passportExpDate: string
  passportIssuedPlace: string
  passportIssuedDate: string
  token: string
  underNoticeDate: string
  candidateId: string
  underNotice: string
  emailId: string
  empManager: string
  bloodgroup: string
  rbtCvPath: string
  rbtCvName: string
  timeSlotDTO: string
  technology: string
  hrAssociate: string
  lateComingCount: string
  passportFrontPagePath: string
  passportBackPagePath: string
  passportFrontPage: string
  passportBackPage: string
  projectManager: string
  casualLeaveCount: number
  lopLeaveCount: number
  holidaysCount: number
  contractExists: string
  contractStartDate: string
  contractEndDate: string
  personalEmail: string
  experience: string
  companyExperience: string
  updatedExperience: string
  country: string
  workStatus: string
  comments: string
  vendorId: string
  vendorName: string
  countryCodeWork: string
  countryCodeMobile: string
  countryCodeHome: string
  countryCodeEmergency: string
  countryCodeAlternative: string
  address: string
}

export type EmployeeDetailsResponse = {
  aboutMe: null | string
  absentCount: number
  acknowledged: null | string
  address: null | string
  alternativeMobile: null | string
  anniversary: null | string
  bankInformationList: null | string
  baseLocation: null | string
  bioAttendanceDtoSet: null | string
  bloodgroup: null | string
  candidateId: null | string
  casualLeaveCount: number
  comments: null | string
  companyExperience: null | string
  contractEndDate: null | string
  contractExists: null | string
  contractStartDate: null | string
  country: null | string
  countryCodeAlternative: null | string
  countryCodeEmergency: null | string
  countryCodeHome: null | string
  countryCodeMobile: null | string
  countryCodeWork: null | string
  curentLocation: null | string
  dateOfJoining: null | string
  dates: null | string
  departmentName: null | string
  designation: null | string
  designationKrasDTO: null | string
  dob: null | string
  emailId: null | string
  emergencyContact: null | string
  emergencyContactName: null | string
  emergencyPhone: null | string
  emergencyRelationShip: null | string
  empManager: null | string
  employeeSubmitted: null | string
  employmentTypeName: null | string
  experience: null | string
  firstName: null | string
  fullName: string
  gender: null | string
  grade: null | string
  holidaysCount: number
  homeCode: null | string
  homeNumber: null | string
  hrAssociate: null | string
  id: number
  imageData: null | string
  informationList: null | string
  jobTypeName: null | string
  lastName: null | string
  lateComingCount: null | string
  lopLeaveCount: number
  manager: null | string
  managerSubmitted: null | string
  maritalStatus: null | string
  middleName: null | string
  mobile: null | string
  observationDTOList: null | string
  officialBirthday: null | string
  passportBackPage: null | string
  passportBackPagePath: null | string
  passportExpDate: null | string
  passportFrontPage: null | string
  passportFrontPagePath: null | string
  passportIssuedDate: null | string
  passportIssuedPlace: null | string
  passportNumber: null | string
  percent: null | string
  permanentAddress: null | string
  permanentCity: null | string
  permanentLandMark: null | string
  permanentZip: null | string
  personalEmail: null | string
  presentAddress: null | string
  presentCity: null | string
  presentLandMark: null | string
  presentZip: null | string
  profilePicGeneratedPath: null | string
  profilePicPath: null | string
  projectManager: null | string
  rbtCvName: null | string
  rbtCvPath: null | string
  realBirthday: null | string
  relievingDate: null | string
  role: null | string
  skillList: null | string
  skypeId: null | string
  statusName: null | string
  technology: null | string
  thumbPicture: null | string
  timeSlotDTO: null | string
  token: null | string
  underNotice: null | string
  underNoticeDate: null | string
  updatedExperience: null | string
  userName: null | string
  vendorId: null | string
  vendorName: null | string
  workCode: null | string
  workNumber: null | string
  workStatus: null | string
}
export type ProjectList = {
  address: null
  allocation: null
  bcc: null
  billable: false
  billingContactPerson: null
  billingContactPersonEmail: null
  cc: null
  checkListExist: null
  client: null
  clientId: null
  clientName: null
  count: null
  country: null
  deliveryManager: null
  description: null
  domain: null
  email: null
  employeeId: null
  enddate: null
  health: null
  hiveProjectFlag: null
  hiveProjectName: null
  id: 23
  intrnalOrNot: null
  isAllocated: null
  managerId: null
  managerName: null
  model: null
  newClient: null
  organization: null
  personName: null
  platform: null
  projectCode: null
  projectContactEmail: null
  projectContactPerson: null
  projectEndDate: null
  projectName: ''
  projectRequestId: null
  projectRequestMilestoneDTO: null
  projectStartdate: null
  requestedBy: null
  requiredResources: null
  startdate: null
  statuEditFlag: null
  status: null
  technology: null
  type: null
}
export type VendorListResponse = {
  vendorId: number
  vendorName: string
  vendorAddress: string
  vendorCity: string
  vendorState: string
  vendorPincode: string
  vendorCountry: string
  vendorEmailId: string
  vendorPhoneNumber: string
  vendorFaxNumber: string
  departmentId: number
  departmentName: string
  createdBy: string
  updatedBy: string
  createdDate: string
  updatedDate: string
  isExpenseVendor: boolean
  vendorBankDetails: string
  vendorGSTNumber: string
}
export enum employeePaymentStatus {
  'notpaid' = 'Not Paid',
  'paid' = 'Paid',
  'partiallypaid' = 'Partially Paid',
}

export type SavePaymentFormParams = {
  expenseId: number
  modeOfPayment: string
  paidAmount: number
  chequeDate?: string
  chequeNumber?: number
  rtgsDate?: string
}
export type GetExpenseDetails = {
  formId: number
  expenseNumber: string
  toEmployee: EmployeeDetailsResponse
  categoryId: number
  categoryName: string
  subCategoryId: number
  subCategoryName: string
  deptId: number
  deptName: string
  project: null
  vendor: null
  purpose: string
  expenditureDate: string
  country: string
  currencyId: number
  currencyType: string
  paymentMode: string
  creditCardDetails: CreditCardListResponse
  chequeNumber: null
  chequeDate: null
  voucherNumber: string
  amount: string
  description: string
  isReimbursable: true
  empId: number
  saltKey: null
  paymentStatus: string
  remainingAmount: null
  amountInINR: string
  createdBy: string
  createdDate: string
  updatedBy: null
  updatedDate: null
  invoiceNumber: null
  isAutogenerated: null
}
export enum PaymentListDateFiltersEnums {
  currentMonth = 'Current Month',
  custom = 'Custom',
  lastMonth = 'Last Month',
  lastWeek = 'Last Week',
  thisWeek = 'This Week',
  today = 'Today',
  yesterday = 'Yesterday',
}
export type EmpDepartmentList = {
  departmentId: number
  departmentName: string
  supportManagementFlag: boolean
  allocationSupportFlag: boolean
}
export type GetExpensePaymentList = {
  expenseId: number
  modeOfPayment: string
  paidAmount: string | number
  chequeNumber: null
  chequeDate: null
  rtgsDate: null
  status: string
  saltKey: null
  createdBy: string
  createdDate: string
  id: number
}
export type GetExpensePaymentListProps = {
  expenseId: number
}
export type GetpayAllAtOnceProps = {
  formsIds?: number[]
  chequeDate?: string
  chequeNumber?: number
  modeOfPayment?: string
  paidAmount?: number
  rtgsDate?: string
}
